/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorAppInfo } from '../../models/editor-app-info';

export interface AppControllerFindEditorAppList$Params {
  language: string;
}

export function appControllerFindEditorAppList(http: HttpClient, rootUrl: string, params: AppControllerFindEditorAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorAppInfo>>> {
  const rb = new RequestBuilder(rootUrl, appControllerFindEditorAppList.PATH, 'get');
  if (params) {
    rb.path('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EditorAppInfo>>;
    })
  );
}

appControllerFindEditorAppList.PATH = '/app/editorList/{language}';
